import React from 'react'
import PropTypes from 'prop-types'

import EditItemButtons from '../common/EditItemButtons'
import TextParser from '../common/TextParser'

import Toggle from 'material-ui/Toggle';

export default class TaskEditItem extends React.Component {

  static defaultProps = {
    text: '',
    showReminder: false,
  }

  static propTypes = {
    text: PropTypes.string,
    reminderId: PropTypes.string,
    showReminder: PropTypes.bool,
    enableReminders: PropTypes.bool,
    mode: PropTypes.oneOf([ 'edit', 'add' ]).isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onDelete: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      text: props.text,
      showReminder: props.showReminder
    }
  }

  componentDidMount() {
    if (this.tasksInput) {
      this.tasksInput.focus()
    }
  }

  handleSave = () => {
    if (!this.state.text) {
      alert('Task name field is required.')
    }
    else {
      const { text, showReminder } = this.state
      this.props.onSave({ text, showReminder })
    }
  }

  handleTextChange = event => {
    event.preventDefault()
    this.setState({ text: event.target.value })
    // Adjust the rows of the input area to the number of lines entered.
    const tasks = TextParser.parse(event.target.value, false)
    this.tasksInput.rows = tasks.length
  }

  handleShowReminderChange = (event, value) => {
    event.preventDefault()
    this.setState({ showReminder: value })
  }

  handleKeyDown = event => {
    if (event.nativeEvent.keyCode === 13) {
      if (event.nativeEvent.shiftKey) {
        return true
      }
      else {
        event.preventDefault()
        this.handleSave()
        return false
      }
    }
    return event.keyCode !== 13
  }

  render() {
    return (
      <div
        style={{ display: 'flex', flexGrow: 1, flexDirection: 'column'}}>
        <div
          style={styles.row}>
          <div style={styles.rowKey}>Task Label: </div>
          <textarea
            style={styles.editArea}
            type='text'
            rows={1}
            placeholder='Type task name, shift + enter for new line'
            ref={textarea => this.tasksInput = textarea}
            value={this.state.text}
            onChange={this.handleTextChange}
            onKeyDown={this.handleKeyDown} />
        </div>
        {
          this.props.enableReminders
          &&
          <div
            style={styles.row}>
            <div style={styles.rowKey}>Set As Reminder: </div>
            <div style={{ flexGrow: 3  }}>
              <Toggle
                toggled={this.state.showReminder}
                onToggle={this.handleShowReminderChange}/>
            </div>
          </div>
        }

        <EditItemButtons
          primaryButtonText={this.props.mode === 'add' ? 'Add' : 'Save'}
          onCancel={this.props.onCancel}
          onDelete={this.props.onDelete}
          onSave={this.handleSave} />
      </div>
    )
  }

}

const styles = {

  row: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 4,
    marginBottom: 4
  },

  rowKey: {
    marginRight: 16,
    fontSize: 14,
    flexGrow: 1,
    maxWidth: 160,
  },

  editArea: {
    flexGrow: 3,
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    backgroundColor: '#fefefe',
    borderRadius: 3,
    boxShadow: 'inset 0 2px 2px 0 rgba(0, 0, 0, 0.05)',
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    resize: 'vertical',
    maxHeight: 120
  },

  addTask: {
    cursor: 'pointer',
    color: '#356992'
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/tasks/TaskEditItem.js